import { axiosPublic } from '../../publicRest'
import { initApollo } from './apollo'
import gql from 'graphql-tag'
import { initialize } from './global-labels'
import { I18nLabelsQuery } from '../types/graphql'
import { PortalPropertiesDTO } from '@/core/types/properties'

export const getProperties = async () => {
  const response =
    await axiosPublic.get<PortalPropertiesDTO>('/portalProperties')
  return response.data
}

export const initializeFaviconAndTitle = (manifest: {
  name?: string
  favicon?: string
}) => {
  const { favicon, name } = manifest

  document.querySelector('#favicon')?.setAttribute('href', String(favicon))
  document.title = String(name)
}

export const initializeI18n = async (client: ReturnType<typeof initApollo>) => {
  const query = await client.query<I18nLabelsQuery>({
    query: gql`
      query I18nLabels {
        i18nLabels {
          key
          value
        }
      }
    `
  })

  initialize(query.data.i18nLabels)
}
